module.exports = __webpack_public_path__ + "assets/img/Logitech-G-Global-Landing-Page-w540.daa9a531.webp";